import React from 'react';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import DatePicker from '@dealroadshow/uikit-picker/DatePicker';
import getDateFromUnixTime from '@framework/date-helpers/getDateFromUnixTime';
import utcToZonedDate from '@framework/date-helpers/utcToZonedDate';
import styles from '@framework/ui/Organisms/Filters/FiltersPanel/sidebar.module.scss';

interface IProps {
  dateFrom: number,
  dateTo: number,
  dateFromMin?: number,
  dateToMax?: number,
  timeZone?: string | null,
  onDateFromChange?: (value: Date) => void,
  onDateToChange?: (value: Date) => void,
  isDateFromDisabled?: boolean,
  isDateToDisabled?: boolean,
}

function DatePeriod({
  timeZone = null,
  ...props
}: IProps) {
  let dateFromMin = null;
  let dateToMax = new Date();
  let dateFromSelected = dateFromMin;
  let dateToSelected = dateToMax;

  if (props.dateFromMin) {
    // @ts-ignore
    dateFromMin = getDateFromUnixTime(props.dateFromMin);
    if (timeZone) {
      // @ts-ignore
      dateFromMin = utcToZonedDate(timeZone, dateFromMin);
    }
  }

  if (props.dateToMax) {
    dateToMax = getDateFromUnixTime(props.dateToMax);
    if (timeZone) {
      dateToMax = utcToZonedDate(timeZone, dateToMax);
    }
  }

  if (props.dateFrom || props.dateFromMin) {
    // @ts-ignore
    dateFromSelected = getDateFromUnixTime(props.dateFrom || props.dateFromMin);
    if (timeZone) {
      // @ts-ignore
      dateFromSelected = utcToZonedDate(timeZone, dateFromSelected);
    }
  }

  if (props.dateTo || props.dateToMax) {
    // @ts-ignore
    dateToSelected = getDateFromUnixTime(props.dateTo || props.dateToMax);
    if (timeZone) {
      dateToSelected = utcToZonedDate(timeZone, dateToSelected);
    }
  }

  return (
    <div className={ styles.headerPeriod }>
      { (dateFromSelected && dateToSelected) && (
        <div className={ styles.headerPeriodWrp }>
          <div className={ styles.headerPeriodFrom } data-test="dateFromPicker">
            <DatePicker
              name="startDatePeriodInput"
              value={ dateFromSelected }
              // @ts-ignore
              onChange={ props.onDateFromChange }
              isDisabled={ props.isDateFromDisabled }
              isReadOnly
              isClearable={ false }
              dateFormat={ MONTH_DAY_YEAR_FORMAT }
              placeholder="Start date"
              // @ts-ignore
              minDate={ dateFromMin }
              maxDate={
                props.dateTo
                  ? dateToSelected
                  : dateToMax
              }
              dataTest="datePeriodStartDatePicker"
              inputDataTest="startDatePeriodInput"
              isNarrow
            />
          </div>
          <div className={ styles.headerPeriodLabel }>–</div>
          <div className={ styles.headerPeriodTo } data-test="dateToPicker">
            <DatePicker
              name="endDatePeriodInput"
              value={ dateToSelected }
              // @ts-ignore
              onChange={ props.onDateToChange }
              isDisabled={ props.isDateToDisabled }
              isReadOnly
              isClearable={ false }
              dateFormat={ MONTH_DAY_YEAR_FORMAT }
              placeholder="End date"
              minDate={ dateFromSelected }
              maxDate={ dateToMax }
              dataTest="datePeriodEnsDatePicker"
              inputDataTest="endDatePeriodInput"
              isNarrow
            />
          </div>
        </div>
      ) }
    </div>
  );
}

export default DatePeriod;
